import { render, staticRenderFns } from "./MoveProducts.vue?vue&type=template&id=c518cc66&scoped=true"
import script from "./MoveProducts.vue?vue&type=script&lang=js"
export * from "./MoveProducts.vue?vue&type=script&lang=js"
import style0 from "./MoveProducts.vue?vue&type=style&index=0&id=c518cc66&prod&lang=css"
import style1 from "./MoveProducts.vue?vue&type=style&index=1&id=c518cc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518cc66",
  null
  
)

export default component.exports